module.exports = __webpack_public_path__ + "static/mt-cook-18332ec9da480792f0845e41f1a7e083.jpg";